import { HandySvg } from "handy-svg";
import Image from "next/image";
import styles from "./TryOur.module.scss";
import * as ga from "../../../lib/ga";

const TryOur = ({ dictionary, photos, gaEvent, clickHandler }) => {
	const gaUserUseOurImage = () => {
		ga.event({ action: `${gaEvent}: user use our image`, params: { event_category: `${gaEvent} page` } });
	};

	const handleChoicePhoto = (url) => {
		gaUserUseOurImage();
		clickHandler(url);
	};

	return (
		<section className={styles.container}>
			<p className={styles.title}>{dictionary["try_out"]}</p>
			<HandySvg className={styles.arrow} src={"/erase_and_replace/try_our/arrow_down.svg"} width={35} height={40} />
			<div className={styles.try_our__photo_wrapper}>
				{photos?.map((photo) => (
					<Image key={photo.alt} src={`${photo.previewUrl}`} alt={photo.alt} width="200" height="200" className={styles.photo} onClick={() => handleChoicePhoto(photo.originalUrl)} loading="lazy" />
				))}
			</div>
		</section>
	);
};

export default TryOur;
